/**
 * Build the Sentry `environment` string for a deployment.
 *
 * When a region id is present (non-empty) we suffix the base stage so that
 * multi-region deployments show up as distinct Sentry environments (e.g.
 * `prod-us-1`, `prod-ca-1`). When absent or empty, the base stage is returned
 * unchanged so single-region and local-dev setups keep their existing behaviour.
 *
 * Characters outside `[a-z0-9_-]` are stripped before appending so that
 * accidental whitespace or control characters in the source value cannot produce
 * a malformed environment label.
 */
export const buildSentryEnvironment = (
  stage: string,
  regionId: string | undefined | null
): string => {
  if (!regionId) {
    return stage;
  }

  const sanitized = regionId.toLowerCase().replace(/[^a-z0-9_-]/g, '');

  return sanitized ? `${stage}-${sanitized}` : stage;
};
